// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oy_a bih_a bih_x","FilterForm__vgroup":"oy_b bih_sv"};